let sizeBtn = document.querySelector(".size-guide-btn");
let sizeBtnMobile = document.querySelector(".button-mobile-size-open");
let popup = document.querySelector(".size-popup");
let inner = popup.querySelector(".inner");

if (popup) {
    document.body.appendChild(popup);
    let sizeBtnClose = popup.querySelector(".close");

    let scrollPosition = 0;
    let previousOverlflow = "";
    let previousPosition = "";

    inner.addEventListener("click", function (e) {
        e.stopPropagation();
    });

    popup.addEventListener("click", function () {
        close();
    });
    sizeBtnMobile.addEventListener("click", function () {
        popup.classList.add("show");

        let body = document.body;

        scrollPosition = window.scrollY;
        previousOverlflow = body.style.overflow;
        previousPosition = body.style.position;

        body.style.overflow = "hidden";
        body.style.position = "fixed";

        body.style.top = -scrollPosition + "px";
    });
    sizeBtn.addEventListener("click", function () {
        popup.classList.add("show");

        let body = document.body;

        scrollPosition = window.scrollY;
        previousOverlflow = body.style.overflow;
        previousPosition = body.style.position;

        body.style.overflow = "hidden";
        body.style.position = "fixed";

        body.style.top = -scrollPosition + "px";
    });
    sizeBtnClose.addEventListener("click", function () {
        close();
    });

    function close() {
        popup.classList.remove("show");
        let body = document.body;
        setTimeout(() => {
            popup.querySelector('.content').scrollTop = 0;
        },200)
        body.style.overflow = previousOverlflow;
        body.style.position = previousPosition;

        body.style.top = 0;
        window.scrollTo(0, scrollPosition);
    }
}
